<script>
	import { PUBLIC_PATH } from '$env/static/public';
	export let productsData;
</script>

<section
	aria-label="Our Products"
	class="relative overflow-hidden bg-primary py-8 lg:py-14"
	id="products"
>
	<!-- Background grid -->
	<div
		class="pointer-events-none absolute inset-0 opacity-[0.26] bg-repeat mix-blend-overlay"
		style="background-image: url('{PUBLIC_PATH}/images/grid-line.svg');"
	></div>

	<div class="relative mx-auto max-w-8xl px-padding_lg lg:px-3">
		<h2
			class="text-center text-[1.1875rem] font-semibold leading-[1.5rem] text-white lg:font-barlow lg:text-[2.5rem] lg:leading-[3.5rem]"
		>
			{productsData.title}
		</h2>

		<div
			class="mt-padding_xxlg flex flex-col items-center justify-center gap-4 lg:gap-12 lg:mt-space_40 lg:flex-row lg:mb-10"
		>
			{#each productsData.items as product, index}
				<div class="relative max-w-[25rem] w-full">
					<div
						class="absolute rounded-shape-corner_sm {product.accentClass}"
						style={product.accentStyle}
					></div>

					<div
						class="relative {index === 0
							? 'ml-padding_lg'
							: 'mr-padding_lg'} lg:h-[20rem] rounded-shape-corner_sm bg-background-alt px-padding_xlg pb-[1.75rem] pt-padding_xxlg shadow-elevation_level3 lg:ml-0 lg:mr-0 lg:px-padding_xxlg"
					>
						<div class="text-center">
							<h3
								class="text-[1.0625rem] font-semibold leading-[1.5rem] text-backdrop lg:text-[1.1875rem]"
							>
								{product.title}
							</h3>
							<img class="my-padding_xsm" src="{PUBLIC_PATH}/images/line.svg" alt="line" />
							<div class="mt-padding_xsm body_small tracking-[0.0015rem] text-body lg:body_large">
								{product.description}
							</div>
						</div>

						<div class="mt-padding_lg flex items-center justify-center lg:mt-padding_xxlg">
							<img
								class="h-[8.75rem] w-[12.5rem] object-contain"
								src="{PUBLIC_PATH}/{product.image}"
								alt={product.altText}
							/>
						</div>
					</div>
				</div>
			{/each}
		</div>
	</div>
</section>
